import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class ErrorService {
    private _authService: AuthService = inject(AuthService);

    private _errorMessage = new BehaviorSubject<string | null>(null);

    get errorMessage$(): Observable<string | null> {
        return this._errorMessage.asObservable();
    }

    setError(message: string): void {
        this._errorMessage.next(message);
        this._authService.signOut();
    }

    clearError(): void {
        this._errorMessage.next(null);
    }
}

